import { Injectable } from "@angular/core";

import { Observable, catchError } from "rxjs";

import { ApiResponse, RequestOptions, TemplateHelper } from "@venecia/apis/base";

import { ApiTemplate } from "../base/template/api.template";
import { Client, ClientRequest } from "./model/client.model";
import { RoleReference } from "./model/role.model";

@Injectable({ providedIn: 'root' })
export class ClientApi extends ApiTemplate<Client, ClientRequest> {
    constructor() {
        super('http.rest.identity.url', "/api/clients");
    }

    updateRoles(clientId: number, roles: readonly RoleIdPayload[], options?: RequestOptions): Observable<ApiResponse<unknown>> {
        const url = this.urlBuilder!.build(`${clientId}/roles`);
        const httpOptions = TemplateHelper.buildOptions(options);

        return this.http
            .put<ApiResponse<unknown>>(url, roles, httpOptions)
            .pipe(
                TemplateHelper.applyRetry(options),
                catchError((err) => TemplateHelper.handleError(err))
            );
    }
}

export interface RoleIdPayload extends RoleReference {
    id: number;
}
